// extracted by mini-css-extract-plugin
export default {"app-card-grid-layout":"show-apps_app-card-grid-layout__Ea+pM","app-card":"show-apps_app-card__A2u27"};